import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { DomSanitizer } from '@angular/platform-browser';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'formly-code-type',
  template: `
    <div class="mb-3">
      <!--<h3 *ngIf="to.label">{{ to.label }}</h3> -->
      <!-- <p *ngIf="to.description">{{ to.description }}</p> -->

      <label *ngIf="to.label" [for]="'quill-' + field.id" style="display: block">
        {{ to.label }}
      </label>
      <div class="alert alert-danger" role="alert" *ngIf="showError && formControl.errors">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
      <quill-editor
        [id]="'quill-' + field.id"
        #editor
        [styles]="{ backgroundColor: '#fff' }"
        [formControl]="formControl"></quill-editor>
      <p *ngIf="to.description" style="font-size: small; padding: 0 16px; margin-top: 0">
        {{ to.description }}
      </p>
    </div>
  `
})
export class HtmlWithPreviewTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  @ViewChild('iframe') iframe: ElementRef;

  private updateIframe(content: string): void {
    const win: Window = this.iframe.nativeElement.contentWindow;
    const doc: Document = win.document;
    doc.open();
    doc.write(content);
    doc.close();
  }

  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit(): void {
    this.formControl.valueChanges.pipe(tap((x) => this.updateIframe(x.value)));
  }
}
